let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jfz2k")).then(() => parcelRequire('5QZzy'));